import React from 'react'
import { Route } from 'react-router-dom'
const Layout = React.lazy(() => import('./Layout'))
const NotFound = React.lazy(() => import('./NotFound'))
const Landing = React.lazy(() => import('./Landing'))
const TermsOfServiceUpdated = React.lazy(() => import('./TermsOfServiceUpdated'))
const Terms = React.lazy(() => import('./Terms'))
const IntroducingBrokerTerms = React.lazy(() => import('./IntroducingBrokerTerms'))
const Privacy = React.lazy(() => import('./Privacy'))

// prettier-ignore
export default (
  <Route element={<React.Suspense><Layout /></React.Suspense>}>
    <Route path="/" element={<React.Suspense><Landing /></React.Suspense>} />
    <Route path="/terms-of-service-updated" element={<React.Suspense><TermsOfServiceUpdated /></React.Suspense>} />
    <Route path="/terms-and-conditions" element={<React.Suspense><Terms /></React.Suspense>} />
    <Route path="/introducing-broker-contract" element={<React.Suspense><IntroducingBrokerTerms /></React.Suspense>} />
    <Route path="/privacy-policy" element={<React.Suspense><Privacy /></React.Suspense>} />
    <Route path="*" element={<React.Suspense><NotFound /></React.Suspense>} />
  </Route>
)
